import React, { useEffect, useState, useRef } from 'react';
import style from './SortingDropdown.module.css';
import { ReactComponent as SelectedCircle } from "./SelcetedCircle.svg";
import { ReactComponent as EmptyCircle } from "./EmptyCircle.svg";

const SortingDropdown = ({ onSelect, options, currentSortOption, isOpen }) => {
    const [isClosing, setIsClosing] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);
    const contentRef = useRef(null);
    
    useEffect(() => {
        if (isOpen) {
            setIsClosing(false);
            setShouldRender(true);
        } else {
            setIsClosing(true);
            // 애니메이션이 끝난 후에 컴포넌트를 실제로 제거
            const timer = setTimeout(() => {
                setShouldRender(false);
            }, 200); // 애니메이션 지속 시간과 동일하게 설정
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    if (!shouldRender) return null;

    return (
        <div 
            className={`${style.dropdownContainer} ${
                isClosing ? style.dropdownExit : style.dropdownEnter
            }`} 
            ref={contentRef}
        >
            {options.map((option, index) => (
                <button
                    key={option}
                    onClick={() => onSelect(option)}
                    className={`${style.dropdownItem} ${
                        option === currentSortOption ? style.selected : ''
                    } ${isClosing ? style.dropdownItemExit : style.dropdownItemEnter}`}
                    style={{ 
                        animationDelay: isClosing 
                            ? `${(options.length - 1 - index) * 0.05}s` 
                            : `${index * 0.05}s` 
                    }}
                >
                    {option}
                </button>
            ))}
        </div>
    );
};

export default SortingDropdown;


